import { ComponentRef, ViewContainerRef } from '@angular/core';
import { SimpleSubRoute, WithParamsSubRoute } from 'authorization';
export interface linkItem {
  type: 'string' | 'class';
  link: {
    url: urlType;
    label: string;
    newTab: boolean;
  };
}
export type urlType = SimpleSubRoute | WithParamsSubRoute<any> | string;

export class HeaderRouteStrartegy {
  private static urlRepo = new Map<string, any>();
  static lastComponentInstance: ComponentRef<any>;
  static setRouteStrategy(key: 'string' | 'class', data: any) {
    this.urlRepo.set(key, data);
  }

  static executeRouteStrategy(
    type: 'string' | 'class',
    link: {
      url: urlType;
      label: string;
      newTab: boolean;
    },
    container: ViewContainerRef,
  ) {
    const hyperLink = this.urlRepo.get(type);
    console.log(this.urlRepo);
    console.log(hyperLink);
    console.log(container);
    if (hyperLink !== undefined) {
      const componentRef = container.createComponent(hyperLink);
      componentRef.instance['data'] = link;
      return componentRef;
    }
    return null;
  }
}
